import { GuardianRequestInfo } from "@/data/common/guardian-request-info";
import { PatientRequestInfo } from "@/data/common/patient-request-info";
import { UpdatePatientInfoRequestPayload } from "@/data/payload/patient/update-paitent-info-request-payload";
import { PatientRepository } from "@/domain/repository/patient-repository";
import { SATError, SATResult } from "@sadtx/sat-error";

export class UpdatePatientInfoUsecase {
  //MARK:- Constructor
  constructor(private readonly patientRepo: PatientRepository) {}

  //MARK:- execute
  async execute(
    patientUuid: string,
    patientInfo: PatientRequestInfo,
    guardianInfo: GuardianRequestInfo
  ): Promise<SATResult<void, SATError>> {
    const payload: UpdatePatientInfoRequestPayload = {
      patientUuid,
      payload: {
        patient: patientInfo,
        guardian: guardianInfo,
      },
    };

    console.log("updatePatientInfo", payload.payload);
    const result = await this.patientRepo.updatePatientInfo(payload);
    if (result.isFailure) {
      return SATResult.failure(result.error);
    }
    return SATResult.success(void 0);
  }
}
